import SkiniverIndex from "@/pages/skiniver/index.vue";
import SkiniverList from "@/pages/skiniver/skiniver-list.vue";
import SkiniverDetail from "@/pages/skiniver/skiniver-detail.vue";
import SkiniverConsent from "@/pages/skiniver/skiniver-consent.vue";
import SkiniverInstructions from "@/pages/skiniver/skiniver-instructions.vue";
import SkiniverResult from "@/pages/skiniver/skiniver-result.vue";

const routes: Route[] = [
  {
    path: "/skiniver",
    component: SkiniverIndex,
    meta: {
      allowAnonymous: true
    },
    children: [
      {
        path: "",
        name: "skiniver.lista",
        component: SkiniverList,
        meta: {
          backTo: "/",
          allowAnonymous: true
        }
      },
      {
        path: "detalhe/:id",
        name: "skiniver.detalhe",
        component: SkiniverDetail,
        props: true,
        meta: {
          backTo: "/skiniver",
          allowAnonymous: true
        }
      },
      {
        path: "novo",
        name: "skiniver.inicio",
        component: SkiniverConsent,
        meta: {
          backTo: "/skiniver",
          allowAnonymous: true
        }
      },
      {
        path: "instrucoes",
        name: "skiniver.instrucoes",
        component: SkiniverInstructions,
        meta: {
          backTo: "/skiniver/novo",
          allowAnonymous: true
        }
      },
      {
        path: "resultado",
        name: "skiniver.resultado",
        component: SkiniverResult,
        meta: {
          backTo: "/skiniver",
          allowAnonymous: true
        }
      }
    ]
  }
];

export default routes;
